// Logo motion video hero. Plays once (muted, inline) and holds the final frame; looping would
// flash back to the blank first frame. The video is cropped to the band that holds the wordmark
// and illustration, which also hides the draft labels baked into the file. The poster (final
// frame) shows while loading, on browsers without WebM, and for reduced-motion visitors.
// The same words are in the page for screen readers and crawlers.
(function () {
  const { useEffect, useRef, useState } = React;
  const h = React.createElement;
  const BASE = window.ASSET_BASE || "";

  function PtVideoHero() {
    const ref = useRef(null);
    const [done, setDone] = useState(false);

    useEffect(() => {
      const v = ref.current; if (!v) return;
      v.muted = true;   // required for autoplay; React does not always reflect the muted attribute
      const calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (calm || !v.canPlayType('video/webm; codecs="vp9"') && !v.canPlayType("video/webm")) { setDone(true); return; }
      const p = v.play(); if (p && p.catch) p.catch(() => setDone(true));   // autoplay blocked: keep the poster
    }, []);

    return h("div", { className: "hero-main hero-video" + (done ? " is-done" : "") },
      h("h1", { className: "visually-hidden" }, "ThePawtherapy. Everyday care, with style. Thoughtfully chosen, lovingly shared."),
      h("img", { className: "hero-video-media hero-video-poster", src: BASE + "paw-therapy-logo-poster.webp", alt: "", fetchPriority: "high", decoding: "async" }),
      h("video", {
        ref, className: "hero-video-media", src: BASE + "paw-therapy-logo-motion.webm",
        muted: true, playsInline: true, preload: "auto", "aria-hidden": "true", tabIndex: -1,
        onEnded: () => setDone(true),
      })
    );
  }

  window.PtVideoHero = PtVideoHero;
})();
